<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Report Income Statement Dimension All(Best {{ filter.DimLimit }})
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="process()">
            <i class="fa fa-play"></i>
            Process
          </button>
          <button class="btn btn-primary mr-1" @click="print()">
            <i class="fa fa-print"></i>
            print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 100px"
                >Line Layout</label
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.layout"
              :plain="true"
              :options="layouts"
              :state="!$v.filter.layout.$error"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Dimmension</span></b-input-group-prepend
            >

            <b-form-select
              v-model="filter.DimCol"
              :plain="true"
              :options="dimension"
              :state="!$v.filter.DimCol.$error"
            ></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 100px"
                >Date Range</label
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="filter.tgl1"
              type="date"
              placeholder="from date"
              :state="!$v.filter.tgl1.$error"
              class="mr-1"
            ></b-form-input>
            <b-form-input
              v-model="filter.tgl2"
              type="date"
              placeholder="until date"
              @change="updateTgl1"
              :state="!$v.filter.tgl2.$error"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2"
                >Max. Dimension Col.</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="filter.DimLimit"
              type="number"
              :min="3"
              :state="!$v.filter.DimLimit.$error"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="pl-2 pt-2 mr-2"
                >Sort By</span
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.sortBy"
              :plain="true"
              :options="revenueCost"
              :state="!$v.filter.sortBy.$error"
            ></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>

      <b-card no-body>
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th>Description</th>
                <th
                  style="text-align: right"
                  width="100px"
                  v-for="kol in rptPnl.koloms"
                  :key="kol.kode"
                >
                  {{ kol.nama }}
                </th>
                <th style="text-align: right" width="110px">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rptPnl.lines" :key="row.idrowunik">
                <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                <td
                  :class="row.kelas"
                  v-for="kol in rptPnl.koloms"
                  :key="kol.kode"
                  style="text-align: right"
                >
                  <span
                    v-if="row.kode || row.rumus"
                    @click="drillDownListTrx(kol, row)"
                    >{{ row[`K${kol.kode.trim()}`] | numFormat }}</span
                  >
                </td>
                <td
                  :class="row.kelas"
                  v-if="row.kode || row.rumus"
                  style="text-align: right"
                >
                  {{ row.total | numFormat }}
                </td>
                <td v-else></td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;

  table {
    font-size: smaller;
    th {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    td {
      border-bottom: 1px solid #f5f5f5;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    td.subtotal {
      border-top: 2px solid #000 !important;
    }

    td.total {
      border-top: 2px solid #000 !important;
      background: #e6e6e6 !important;
    }

    td.grdtotal {
      border-top: 2px solid #000 !important;
      border-bottom: 2px solid #000 !important;
      background: #e6e6e6 !important;
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import incomestat from "../../apis/incomestat";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
      layout: { required },
      DimCol: { required },
      tgl1: { required },
      tgl2: { required },
      DimLimit: { required },
      sortBy: { required },
    },
  },
  data() {
    return {
      filter: {
        DimCol: "",
        layout: "",
        tgl1: "",
        tgl2: "",
        DimLimit: 10,
        sortBy: "REVENUE",
      },
      revenueCost: ["REVENUE", "COST"],
      isLoading: false,
      layouts: [],
      horizontal: true,
      lkuDimShow: false,
      reportUrl: null,
      showReport: false,
      rptPnl: { lines: [], koloms: [] },
    };
  },
  components: { Loading },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    dimCol() {
      return this.filter.DimCol;
    },
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
      return this.filter.layout;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.filter.DimColInfo = this.dimension.find(
        (d) => d.value === newval
      ).text;
    },
    layout: async function (newval) {
      //   this.rptPnl.lines= await incomestat.layout({layout : newval});
      const lines = await incomestat.layout({ layout: newval });
      const hasil = lines.reduce((newArr, line) => {
        if (line.item_hapus !== 1) newArr.push(line);
        return newArr;
      }, []);
      this.rptPnl.lines = hasil;
    },
  },
  created: async function () {
    this.layouts = await incomestat.layout_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
      .add(1, "M")
      .subtract(1, "day");
    var tgl1 = moment(tgl2.format("YYYY") + "-01-01", "YYYY-MM-DD");
    this.filter.tgl1 = tgl1.format("YYYY-MM-DD");
    this.filter.tgl2 = tgl2.format("YYYY-MM-DD");
    this.filter.DimCol = this.dimension[0].value;
  },
  methods: {
    updateTgl1: function () {
      var tgl2 = moment(this.filter.tgl2, "YYYY-MM-DD");
      var tgl1 = moment(tgl2.format("YYYY") + "-01-01", "YYYY-MM-DD");
      this.filter.tgl1 = tgl1.format("YYYY-MM-DD");
    },
    process: async function () {
      if (this.invalidFilter) {
        const invalidobj = {};
        for (var key in this.$v.filter) {
          if (this.$v.filter[key].$anyError) {
            if (this.$v.filter[key].$anyError == true)
              invalidobj[key] = this.$v.filter[key];
          }
        }
        console.log("validation filter: ", this.filter);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        var tgl2 = moment(this.filter.tgl2).format("YYYY");
        var tgl1 = moment(this.filter.tgl1).format("YYYY");
        if (tgl1 !== tgl2) {
          toastr.error("Year of date range is incorrect.", "ERROR MESSAGE");
          return;
        }

        this.isLoading = true;
        try {
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          let arrRes = await incomestat.pnldim10(model);
          this.rptPnl.lines = arrRes[0];
          this.rptPnl.koloms = arrRes[1];
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    drillDownListTrx: function (kol, row) {
      if (row.kode && row[`K${kol.kode.trim()}`]) {
        // let routeData = router.resolve({path: `dim-detailtrx/${kol.DimColName}/${kol.kode}/${data.kode}/${moment(this.filter.tgl1).format('YYYY-MM-DD')}/${moment(this.filter.tgl1).format('YYYY-MM-DD')}`);
        let routeData = router.resolve({
          name: "accounting.glpnldim",
          params: {
            DimCol: kol.DimColName,
            DimVal: kol.kode,
            DimValInfo: kol.display,
            kodeaw: row.kode,
            tgl1: this.filter.tgl1,
            tgl2: this.filter.tgl2,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },

    print: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.showReport = true;
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          this.reportUrl = await incomestat.pnldim10print(model);
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          const response = await incomestat.pnldim10export(model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>
